import axios from 'axios';
import { clearSessionUser, getSessionXsrfToken } from './utils/SessionUser';

function resolveApiBase() {
  // URL para local hosting
  //const apiUrl = `http://localhost:7023/api`;

  // URL para producción (por defecto)
  const apiUrl = `https://capsamex-trains.lat/api`;



  return apiUrl;
}

export const API_BASE = resolveApiBase();

// Crear una instancia centralizada de Axios
const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,       // Requerido para enviar cookies HttpOnly (FASE 4)
  xsrfCookieName: 'XSRF-TOKEN', // Nombre de la cookie que busca Axios
  xsrfHeaderName: 'X-XSRF-TOKEN', // Nombre del header que enviará de vuelta
  headers: {
    'Content-Type': 'application/json'
  }
});

// INTERCEPTOR DE PETICIÓN: Ya no inyectamos el Token manual (FASE 4)
// El navegador envía automáticamente la cookie HttpOnly si withCredentials es true.
// FASE 5 (CSRF): En lugar de leer document.cookie (que falla en entornos CORS),
// inyectamos el token que guardamos en sessionStorage durante el Login.
api.interceptors.request.use((config) => {
  if (['post', 'put', 'delete', 'patch'].includes(config.method?.toLowerCase())) {
    const xsrfToken = getSessionXsrfToken();
    if (xsrfToken) {
      config.headers['X-XSRF-TOKEN'] = xsrfToken;
    }
  }
  return config;
}, (error) => Promise.reject(error));

// INTERCEPTOR DE RESPUESTA: Manejar errores 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn('Sesión expirada o no autorizada (401). Redirigiendo al login...');
      clearSessionUser();
      // Redirigir al login si no estamos ya ahí
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;